export default __webpack_public_path__ + "static/media/expOrange.10341340.svg";